/**
* @author Indeform Ltd
* @copyright Copyright 2020, Indeform Ltd
* @version 20200305
* @description Login signing component.
*/


import Sign from "../sign";

class LoginSign extends Sign {
    constructor(ui) {
        super(ui, 'login', ['click'], {
            elmForm: 'formLogin',
            elmStatus: 'formStatus',
            statusClassName: 'LoginStatus',
        });
    }
}

export { LoginSign }
export default LoginSign